
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { htmlContent } from '@/components/client/events/EventBodyWithTabs'
import EventHero from '@/components/client/events/EventHero'
import ClientLayout from '@/components/client/layout/Index'
import useBlog from '@/hooks/client/Blogs/useBlog'
import { Avatar } from '@mantine/core'
import dayjs from 'dayjs'
import 'dayjs/locale/ar' // Import Arabic locale
import { NextSeo } from 'next-seo'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import React from 'react'
import BackButton from '@/components/common/BackButton'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share'
import { BsLink45Deg, BsLinkedin, BsTelegram, BsWhatsapp } from 'react-icons/bs'

const BlogPostDetails = () => {
  const router = useRouter()
  const { t, lang } = useTranslation('client')
  const { query } = router

  const { data } = useBlog({ id: parseInt(query?.id as string) })

  const shareLink =
    typeof window === 'undefined' ? '#' : `${window.location.href}`

  const shareMessage = `
@infinity_edu_sa
`

  return (
    <ClientLayout>
      <NextSeo
        title={`${
          lang === 'en'
            ? data?.findManyBlogs[0]?.title
            : data?.findManyBlogs[0]?.titleAr
        } - ${t('appName')}`}
        description={
          htmlContent(
            lang === 'en'
              ? data?.findManyBlogs[0]?.description
              : data?.findManyBlogs[0]?.descriptionAr,
          ) ||
          (lang === 'en'
            ? data?.findManyBlogs[0]?.title
            : data?.findManyBlogs[0]?.titleAr) ||
          ''
        }
        canonical={`https://infinity.edu.sa/blogs/${data?.findManyBlogs[0]?.id}`}
        openGraph={{
          url: `https://infinity.edu.sa/blogs/${data?.findManyBlogs[0]?.id}`,
          title: `${
            (lang === 'en'
              ? data?.findManyBlogs[0]?.title
              : data?.findManyBlogs[0]?.titleAr) ||
            htmlContent(
              lang === 'en'
                ? data?.findManyBlogs[0]?.description
                : data?.findManyBlogs[0]?.descriptionAr,
            )
          }`,
          description: `${
            htmlContent(
              lang === 'en'
                ? data?.findManyBlogs[0]?.description
                : data?.findManyBlogs[0]?.descriptionAr,
            ) ||
            (lang === 'en'
              ? data?.findManyBlogs[0]?.title
              : data?.findManyBlogs[0]?.titleAr)
          }`,
          images: [
            { url: data?.findManyBlogs[0]?.image || '-' },
            { url: data?.findManyBlogs[0]?.thumbnailImage || '-' },
          ],
        }}
      />
      <EventHero images={[data?.findManyBlogs[0]?.image as any] ?? []} />
      <main
        id="courses-heading"
        className="max-w-2xl mx-auto px-4 lg:max-w-7xl lg:px-4"
      >
        <div className="container mx-auto px-4 py-8 min-h-[85vh]">
          <BackButton route="/blogs" />

          <h1 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl my-2">
            {lang === 'en'
              ? data?.findManyBlogs[0]?.title
              : data?.findManyBlogs[0]?.titleAr}
          </h1>
          <div className="mb-2 flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 ">
              <p className="text-sm text-gray-500 mt-2">
                {lang === 'en' ? 'By' : 'من'}
              </p>
              <div className="flex items-center gap-2">
                <Avatar
                  src={data?.findManyBlogs[0]?.author?.image}
                  alt="it's me"
                  sx={{ width: '30px', height: '35px', borderRadius: '50%' }}
                />
                <p className="text-sm text-gray-500 mt-2">
                  {data?.findManyBlogs?.[0]?.author?.name}
                </p>
              </div>
            </div>

            <p className="text-sm text-gray-500 mt-2">
              {dayjs(data?.findManyBlogs[0]?.createdAt).format('YYYY-MM-DD')}
            </p>
          </div>
          <div className="mt-4 flex flex-col items-start gap-2 justify-start">
            {/* <h3 className="text-base font-medium text-gray-900">
              {t('share')}
            </h3> */}
            <ul role="list" className="flex items-center gap-4">
              <li>
                <a
                  href="#"
                  className="flex items-center justify-center w-6 h-6 text-[#1773ea] hover:text-gray-500"
                >
                  <span className="sr-only">Share on Facebook</span>
                  <FacebookShareButton url={shareLink} quote={shareMessage}>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </FacebookShareButton>
                </a>
              </li>

              <li>
                <a
                  href="#"
                  className="flex items-center justify-center w-6 h-6 text-[#1c96e8] hover:text-gray-500"
                >
                  <span className="sr-only">Share on Twitter</span>

                  <TwitterShareButton url={shareLink} title={shareMessage}>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                    </svg>
                  </TwitterShareButton>
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="flex items-center justify-center w-6 h-6 text-[#32a6d8] hover:text-gray-500"
                >
                  <span className="sr-only">Share on Telegram</span>

                  <TelegramShareButton url={shareLink} title={shareMessage}>
                    <BsTelegram className="w-5 h-5" />
                  </TelegramShareButton>
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="flex items-center justify-center w-6 h-6 text-[#0a63bc] hover:text-gray-500"
                >
                  <span className="sr-only">Share on LinkedIn</span>

                  <LinkedinShareButton
                    className="w-5 h-5"
                    url={shareLink}
                    title={shareMessage}
                    source={t('appName')}
                    summary={shareMessage}
                  >
                    <BsLinkedin className="w-5 h-5" />
                  </LinkedinShareButton>
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="flex items-center justify-center w-6 h-6 text-[#3fb154] hover:text-gray-500"
                >
                  <span className="sr-only">Share on Whatsapp</span>

                  <WhatsappShareButton
                    className="w-5 h-5"
                    url={shareLink}
                    title={shareMessage}
                  >
                    <BsWhatsapp className="w-5 h-5" />
                  </WhatsappShareButton>
                </a>
              </li>
              <li>
                <span
                  onClick={() => {
                    navigator.clipboard.writeText(shareLink)
                  }}
                  className="flex items-center justify-center w-6 h-6 text-gray-400 hover:text-gray-500 cursor-pointer"
                >
                  <span className="sr-only">Copy Link</span>

                  <BsLink45Deg className="w-5 h-5" />
                </span>
              </li>
            </ul>
          </div>
          <div className="prose max-w-none">
            <div
              dangerouslySetInnerHTML={{
                __html:
                  lang === 'en'
                    ? data?.findManyBlogs[0]?.content
                    : data?.findManyBlogs[0]?.contentAr,
              }}
            />
          </div>
          <BackButton route="/blogs" />
        </div>
      </main>
    </ClientLayout>
  )
}

export default BlogPostDetails


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/blogs/[id]/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  